module.exports = __webpack_public_path__ + "static/media/authFailed.e84830ee.svg";